import { FilterAdminResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { FilterAdmin } from '../../types/filters.type';

export default class UpdateAdminFilterFeatureFlag extends BaseAdapter<FilterAdminResponse> {
  rawResponse: FilterAdminResponse;

  async adaptResponse(
    filterId: number,
    featureFlag: string | null,
  ): Promise<FilterAdmin> {
    await this.fetchApiResponse(
      `/api/admin/filters/${filterId}/feature-flag`,
      HTTPMethod.Put,
      {
        feature_flag: featureFlag,
      },
    );
    return {
      id: this.rawResponse.id,
      name: this.rawResponse.name,
      displayName: this.rawResponse.display_name,
      description: this.rawResponse.description,
      categoryName: this.rawResponse.category_name,
      categoryDisplayName: this.rawResponse.category_display_name,
      subcategoryName: this.rawResponse.subcategory_name,
      subcategoryDisplayName: this.rawResponse.subcategory_display_name,
      featureFlag: this.rawResponse.feature_flag,
    };
  }
}
